import {css} from '@yandex-delivery/blocks/theme/css'

// Цвет текста на жёлтой кнопке (ButtonTextMain). Blocks Text по умолчанию серый,
// а LinkButton-<a> не ловит глобальный dark-override — форсим on-control цвет.
const ON_CONTROL_COLOR = '#21201F'

export const classes = {
  label: css`
    text-align: center;

    &,
    & * {
      color: ${ON_CONTROL_COLOR} !important;
      font-weight: 600 !important;
    }
  `,
}
